module.exports = __webpack_public_path__ + "static/assets/bc387336c2f768284443a58a1cbf0332.png";